import { useState } from 'react'
import { Layout, Menu, Button, Typography, Dropdown, Avatar } from 'antd'
import { MenuOutlined, LogoutOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, Outlet } from 'react-router-dom'
import { logoutUser } from '../actions/userActions'
import Colors from '../utils/colors'
import { showToast } from '../utils/toast'
import { getMenuItems } from '../utils/menuItems'

const { Header, Sider, Content } = Layout
const { Text } = Typography

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [selectedKeys, setSelectedKeys] = useState([window.location.pathname])
  const [openKeys, setOpenKeys] = useState([])
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(logoutUser())
    showToast('Logout Success', 'success')
  }

  const userProfileItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout
    }
  ]

  const menuItems = getMenuItems(navigate, isMobile, setCollapsed, user?.role)

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        breakpoint="md"
        collapsedWidth="0"
        width={220}
        onBreakpoint={(broken) => {
          setIsMobile(broken)
          setCollapsed(broken)
        }}
        style={{
          backgroundColor: Colors.primary,
          borderRight: `1px solid ${Colors.darkGray}`,
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          zIndex: isMobile ? 1000 : 100,
          boxShadow: isMobile && !collapsed ? '2px 0 8px rgba(0,0,0,0.15)' : 'none'
        }}
      >
        <div style={{ 
          padding: '12px 16px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: `1px solid ${Colors.darkGray}`,
          backgroundColor: Colors.primary,
          height: 55,
          marginBottom: 10,
        }}>
          <img 
            src="/logo.png" 
            alt="Logo" 
            style={{ height: 34, width: 34, marginRight: '10px', borderRadius: 100 }}
          />
          <Text strong style={{ color: Colors.white, fontSize: '14px' }}>
            Vehicle Tax Buddy
          </Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={openKeys}
          onSelect={({ key }) => setSelectedKeys([key])}
          onOpenChange={(keys) => {
            // Close other dropdowns when opening a new one
            if (keys.length > openKeys.length) {
              // Opening a new dropdown - keep only the new one
              setOpenKeys([keys[keys.length - 1]])
            } else {
              // Closing a dropdown
              setOpenKeys(keys)
            }
          }}
          items={menuItems}
          theme="dark"
          style={{
            backgroundColor: Colors.primary,
            border: 'none',
            height: 'calc(100vh - 76px)',
            overflowY: 'auto'
          }}
        />
      </Sider>
      
      <Layout style={{ marginLeft: collapsed || isMobile ? 0 : 220 }}>
        {isMobile && !collapsed && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 999
            }}
            onClick={() => setCollapsed(true)}
          />
        )}
        <Header style={{
          padding: '0 16px',
          background: Colors.white,
          borderBottom: `1px solid ${Colors.darkGray}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'fixed',
          width: `calc(100% - ${collapsed || isMobile ? 0 : 220}px)`,
          zIndex: 99,
          height: 55,
          lineHeight: 55
        }}>
          <Button
            type="text"
            onClick={() => setCollapsed(!collapsed)}
            style={{ color: Colors.primary, padding: 0 }}
          >
            <MenuOutlined style={{ fontSize: '25px' }} />
          </Button>
          
          <span style={{ color: Colors.primary, fontSize: '15px', fontWeight: 'bold' }}>
            Welcome, {user?.name}
          </span>
          
          <Dropdown
            menu={{ items: userProfileItems }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Avatar
              style={{
                backgroundColor: Colors.primary,
                color: Colors.white,
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              size={32}
            >
              {user?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
          </Dropdown>
        </Header>
        
        <Content style={{
          margin: '64px 16px 16px 16px',
          padding: '16px',
          background: Colors.white,
          borderRadius: '8px',
          minHeight: 'calc(100vh - 96px)'
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}

export default MainLayout